import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import logger from '../../utils/logger';
const NewsletterContainer = styled(Stack)(({ theme }) => ({
  gap: '16px'
}));

const NewsletterTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.primary.main
}));

const NewsletterSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  color: '#333333'
}));

const NewsletterForm = styled(Stack)(({ theme }) => ({
  gap: '12px'
}));

const NewsletterInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    '& input': {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
      fontWeight: 400,
      color: '#333333',
      '&::placeholder': {
        color: '#a2a9b0'
      }
    }
  }
}));

const NewsletterButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontSize: '14px',
  fontWeight: 600,
  textTransform: 'uppercase',
  backgroundColor: theme.palette.primary.main,
  color: '#ffffff',
  padding: '12px 24px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark
  }
}));

const NewsletterSignup = ({ newsletter }) => {
  const [value, setValue] = useState('');
  const [isValidValue, setIsValidValue] = useState(true);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setValue(value);
    setIsValidValue(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value && value.trim()) {
      logger.log('Newsletter signup:', value);
      setValue('');
      // Handle newsletter signup
    } else {
      setIsValidValue(false);
    }
  };

  return (
    <NewsletterContainer>
      <NewsletterTitle>
        {newsletter?.title || 'Join a Newsletter'}
      </NewsletterTitle>
      <NewsletterSubtitle>{newsletter?.subtitle || 'Your Contact'}</NewsletterSubtitle>
      
      <NewsletterForm component="form" onSubmit={handleSubmit}>
        <NewsletterInput
          type="text"
          placeholder={newsletter?.placeholder || 'Enter Your Contact'}
          value={value}
          onChange={handleInputChange}
          error={!isValidValue}
          helperText={!isValidValue ? 'Please enter a valid contact value' : ''}
          fullWidth
          size="small"
        />
        <NewsletterButton
          type="submit"
          variant="contained"
        >
          {newsletter?.buttonText || 'Send'}
        </NewsletterButton>
      </NewsletterForm>
    </NewsletterContainer>
  );
};

export default NewsletterSignup;
